// taken from https://github.com/mixonic/ember-cli-deprecation-workflow/issues/156#issuecomment-1727272249
import { registerDeprecationHandler } from '@ember/debug';
import config from 'cio/config/environment';

const SHOULD_THROW = config.environment !== 'production';
// see https://github.com/emberjs/ember.js/issues/20377 for ignoring `ember-string.add-package`
const SILENCED_DEPRECATIONS = [
  'ember-data:deprecate-array-like',
  'ember-data:deprecate-early-static',
  'ember-string.add-package',
];

registerDeprecationHandler((message, options, next) => {
  if (options == null) {
    return next(message, options);
  }

  if (SILENCED_DEPRECATIONS.includes(options.id)) {
    return;
  } else if (SHOULD_THROW) {
    throw new Error(
      `Deprecation error for \`${(options as any).for}\` (\`${options.id}\`): ${message}. For more info see ${
        (options as any).url
      }`,
    );
  }

  next(message, options);
});
